module.exports = __webpack_public_path__ + "img/Logo_KT_SG_3.05293e71.svg";